import { Component, inject, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { ErrorCode } from '@common/http/enums/error-code.enum';
import { AuthUrlService } from '@portal-core/auth/services/auth-url.service';
import { AuthService } from '@portal-core/auth/services/auth.service';
import { License } from '@portal-core/licenses/models/license.model';
import { AvatarBase } from '@portal-core/ui/avatar/util/avatar.base';
import { AutoUnsubscribe } from '@portal-core/util/auto-unsubscribe.decorator';
import { LoadingState } from '@portal-core/util/loading-state';
import { WINDOW } from '@portal-core/util/window.provider';
import { RouterLink } from '@angular/router';
import { LicenseAvatarComponent } from '@portal-core/licenses/components/license-avatar/license-avatar.component';
import { NgIf, NgTemplateOutlet, AsyncPipe } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'mc-license-nav-list-item',
    templateUrl: './license-nav-list-item.component.html',
    styleUrls: ['./license-nav-list-item.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [RouterLink, LicenseAvatarComponent, NgIf, NgTemplateOutlet, MatProgressSpinner, MatIcon, AsyncPipe]
})
@AutoUnsubscribe()
export class LicenseNavListItemComponent implements OnChanges {
  private readonly window = inject<Window>(WINDOW);
  private readonly authService = inject(AuthService);
  private readonly authUrlService = inject(AuthUrlService);

  @Input() license: License;
  @Input() size?: AvatarBase['size'] = 'normal';
  @Input() selected: boolean;

  displayHref: string;
  loadingState: LoadingState<ErrorCode> = new LoadingState<ErrorCode>();
  ngOnChanges(changes: SimpleChanges) {
    if (changes.license) {
      this.displayHref = this.license ? this.authUrlService.buildSubdomainUrlDisplayText(this.license.VanityBaseUrl) : undefined;
    }
  }

  onClicked() {
    this.loadingState.update(true);

    this.authService.requestHandoffToken$(this.license.Id).subscribe({
      next: handoffToken => this.navigateToSubdomainUrl(`/confirm/handoff?code=${encodeURIComponent(handoffToken.Token)}`),
      error: () => this.navigateToSubdomainUrl(''),
    });
  }

  navigateToSubdomainUrl(path: string) {
    this.window.location.href = this.authUrlService.buildSubdomainUrl(this.license.VanityBaseUrl) + path;
  }
}
